import React from "react";

const TermsOfService = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Terms of Service</h1>
      <p>
        <strong>Effective Date:</strong> 19th April, 2025
      </p>

      <p>
        Welcome to the official registration portal for{" "}
        <strong>
          Nursing and Midwifery Council of Nigeria (NMCN) Examiners
        </strong>
        . This website facilitates the registration of qualified nursing
        professionals as <strong>examiners</strong> for NMCN professional
        examinations.
      </p>

      <h4 className="mt-4">1. Eligibility and Purpose</h4>
      <p>
        This platform is intended exclusively for qualified nursing
        professionals in Nigeria who are eligible to serve as examiners under
        the supervision and authority of the Nursing and Midwifery Council of
        Nigeria (NMCN). You affirm that the information you provide during
        registration is accurate and truthful to the best of your knowledge.
      </p>

      <h4 className="mt-4">2. Account Responsibility</h4>
      <p>
        Upon registering, you are responsible for maintaining the
        confidentiality of your login credentials and for all activities that
        occur under your account. Please notify us immediately of any
        unauthorized use of your account.
      </p>

      <h4 className="mt-4">3. Communication</h4>
      <p>
        By registering on this platform, you consent to receive official
        communication from the NMCN via email. These messages may include
        posting letters, assignment details, and updates relevant to your
        examiner duties.
      </p>
      <p>
        We strictly limit our communications to service-related and official
        notifications.{" "}
        <strong>
          You will not receive promotional or unsolicited emails (spam)
        </strong>{" "}
        from this platform.
      </p>

      <h4 className="mt-4">4. Use of the Platform</h4>
      <p>
        You agree to use the platform only for its intended purpose: registering
        and participating in the NMCN examiner program. You may not use this
        website to engage in any activity that violates Nigerian law or the
        integrity of the examination process.
      </p>

      <h4 className="mt-4">5. Termination of Access</h4>
      <p>
        We reserve the right to suspend or terminate your access to the platform
        without prior notice if any information provided is found to be false or
        if your conduct violates these Terms or applicable laws.
      </p>

      <h4 className="mt-4">6. Changes to Terms</h4>
      <p>
        We may revise these Terms of Service at any time. Continued use of the
        platform after changes have been posted will constitute your acceptance
        of the revised terms.
      </p>

      <h4 className="mt-4">7. Contact</h4>
      <p>
        For questions or concerns about these Terms, please contact us at:
        <br />
        📧 <a href="mailto:info@nmcn.gov.ng">Send us a mail</a>
        <br />
        🌐 <a href="https://nmcn.gov.ng/">Visit our website</a>
      </p>
    </div>
  );
};

export default TermsOfService;
